import axios from 'axios';
import {useNavigate} from "react-router";

const instance = axios.create({
    baseURL: 'http://13.126.229.127:8080',
});

instance.interceptors.request.use((config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
        config.headers['X-Token'] = token;
    }
    return config;
});

export default instance;
